import React from 'react';
import { Navigate, Routes as ReactRoutes, Route, useParams } from 'react-router-dom';

import App from '../app/App';
import { b64ToObject } from '../common/util';
import NotFoundPage from '../components/NotFoundPage';
import Home from '../views/home';

const RoutesWithToken = () => {
    const { token } = useParams();
    let data;

    try {
        if (token) {
            data = b64ToObject(token);
            if(!['confirm', 'cancel'].includes(data?.action)) {
                return (<Navigate to="/404" replace />);
            }
            return (
                <Home token={token} data={data} />
            );
        }
        return (<Navigate to="/404" replace />);
    } catch (e) {
        return (<Navigate to="/404" replace />);
    }

    
}

const Routes = () => {
    return (
        <ReactRoutes>
            <Route path="/" element={<App />}>
                <Route path="404" element={<NotFoundPage />} />

                <Route path=":token" element={<RoutesWithToken />} />

                <Route path="/" element={<Navigate to="/404" replace />} />
                {/* <Route path="*" element={<Navigate to="/404" replace />} /> */}
            </Route>
        </ReactRoutes>
    );
}

export default Routes;
